import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class UTAttachedFileListItem extends SearchModelBase {
    userId: string = '';
    date: string | null = null;
    fromDate: string | null = null;
    toDate: string | null = null;
    refNo: string = '';
    title: string = '';
    fileName: string = '';
    fileSize: number|null = null;
    fromFileSize: number|null = null;
    toFileSize: number|null = null;
    contents: string = '';
    tbName: string = '';
    tbId: number = 0;
    opType: string ='';
    number: string = '';
    customerName: string = '';
    agentName: string = '';
    consigneeName: string = '';
    bltbId: number = 0;
    bltbName: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'User ID', width: 90, dataIndex: 'userId', defaultColumnFocus: true }),
        XCol.Create({ col: 2, text: 'Date', width: 100, dataIndex: 'date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 3, text: 'Type', width: 75, dataIndex: 'opType', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Number', width: 150, dataIndex: 'number'}),
        XCol.Create({ col: 5, text: 'Ref. #', width: 150, dataIndex: 'refNo'}),
        XCol.Create({ col: 6, text: 'Customer', width: 120, dataIndex: 'customerName'}),
        XCol.Create({ col: 7, text: 'Agent', width: 120, dataIndex: 'agentName'}),
        XCol.Create({ col: 8, text: 'Consignee', width: 120, dataIndex: 'consigneeName'}),
        XCol.Create({ col: 9, text: 'Title', width: 150, dataIndex: 'title'}),
        XCol.Create({ col: 10, text: 'Attached File Name', width: 150, dataIndex: 'fileName'}),
        XCol.Create({ col: 11, text: 'File Size', width: 80, dataIndex: 'fileSize', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 12, text: 'Contents', width: 355, dataIndex: 'contents'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: UTAttachedFileListItem.prototype.tbId, orderByAscending: false };

    public static formatData(data: UTAttachedFileListItem[]) {
        return data.map((d: UTAttachedFileListItem) => ({
          ...d,
        }));
    }
    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        date: {from: 'fromDate', to: 'toDate'},
        fileSize: {from: 'fromFileSize', to: 'toFileSize'},
    }
}
